import { render, staticRenderFns } from "./ProductsAlerts.vue?vue&type=template&id=38be0d13"
import script from "./ProductsAlerts.vue?vue&type=script&lang=js"
export * from "./ProductsAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports